import React from 'react';
import { isEmpty } from 'lodash';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { tooltipMounter as TooltipMounter } from './tooltipMounter.view';
 *
 * // render
 * <TooltipMounter propName='propValue'/>
 */
export const tooltipMounter = ( props ) => {
    return (
        <div
            className='ui-tooltip-mounter'
            style={ {
                left: props.position.left,
                top: props.position.top,
                marginTop: -10, // add some vertical gap between element and tooltip
                marginLeft: props.position.width / 2, // align tooltip to the center of the element
            } }
        >
            {/* title */}
            {
                isEmpty( props.title ) ? null : (
                    <div className='ui-tooltip-mounter__title'>{ props.title }</div>
                )
            }

            {/* text */}
            <div className='ui-tooltip-mounter__text'>{ props.text }</div>
        </div>
    );
};

// set display name
tooltipMounter.displayName = 'tooltipMounter';

// set default props
tooltipMounter.defaultProps = {
    isVisible: false,
    title: undefined,
    text: undefined,
    position: {
        top: 0,
        left: 0,
        width: 0,
    },
};

// prop types
tooltipMounter.propTypes = {};
